export default {"src":"/_next/static/media/objects.fe110e27.svg","height":107,"width":107};